import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getWMDOrders({ commit }, payload = {
        paginate: '',
        query: ''
    }) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_ORDERS_REQUEST')

        return axios
            .get(`/orders/wmd-orders${paginate}${query}`)
            .then(response => {
                commit('GET_ORDERS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_ORDERS_FAILURE')
                handleApiError(error, 'Pobranie listy zamówień nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getWMDOrder(context, orderId) {
        return axios
            .get(`/orders/wmd-orders/${orderId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o zamówieniu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    refreshWMDOrders() {
        return axios
            .post('/orders/wmd-orders/refresh', {})
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Odświeżanie listy zamówień nie powiodło się.')

                return Promise.reject(error)
            })
    },
    acceptedWMDOrder({ commit }, orderId) {
        return axios
            .patch(`/orders/wmd-orders/${orderId}`, { statusId: 13 })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zamówienie zostało złożone.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Złożenie zamówienia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    canceledWMDOrder({ commit }, orderId) {
        return axios
            .patch(`/orders/wmd-orders/${orderId}`, { statusId: 120 })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zamówienie zostało anulowane.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Anulowanie zamówienia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    removeWMDOrder({ commit }, orderId) {
        return axios
            .patch(`/orders/wmd-orders/${orderId}`, { statusId: 130 })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zamówienie zostało usunięte.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie zamówienia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    deleteWMDOrder({ commit }, orderId) {
        return axios
            .delete(`/orders/wmd-orders/${orderId}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zamówienie zostało odświeżone.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Odświeżenie zamówienia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateWMDOrder({ commit }, payload) {
        return axios
            .patch(`/orders/wmd-orders/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Dane zostały zapisane.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja zamówienia nie powiodła się.')

                return Promise.reject(error)
            })
    },
    sendToProductionWMDOrder({ commit }, payload) {
        return axios
            .post('/orders/wmd-orders-send-to-production', payload)
            .then(response => {
                if (
                    response.data.orderIds && 
                    response.data.notSentOrders &&
                    response.data.notSentOrders.length < response.data.orderIds.length
                ) {
                    commit('SHOW_NOTIFICATION', {
                        type: 'success',
                        message: 'Zamówienia wysłane.'
                    }, {root: true})
                }

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wysłanie zamówień nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getWMDDeliveryStatusNames({ commit }) {
        return axios
            .get('/deliveries/dicts/wmd-delivery-statuses')
            .then(response => {
                commit('GET_WMD_DELIVERY_STATUS_NAMES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów dostaw nie powiodło się.')

                return Promise.reject(error)
            })
    },
    addCommentWMD({ commit }, payload) {
        return axios
            .post('/orders/wmd-order-comments', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Dodano komentarz.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie komentarza nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateWMDDelivery(context, payload) {
        return axios
            .put(`/deliveries/wmd-delivery/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja dostawy nie powiodła się.')

                return Promise.reject(error)
            })
    },
    setWMDOrdersFilters({ commit }, filters) {
        commit('SET_ORDERS_FILTERS', filters)
    },
    clearWMDOrdersFilters({ commit }) {
        commit('CLEAR_ORDERS_FILTERS')
    }
}